export const mutations = {
    STORE_SHIPPINGLINES (state, shippinglines) {
        state.shippinglines =  shippinglines
    },

    STORE_SHIPPINGLINE_UPDATE (state, shippinglineId) {
        let Shippingline = state.shippinglines.find(function(shippingline) {
            return shippingline.id === shippinglineId
        })
        state.systemShippingline = Shippingline
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/shippinglines/mutations.js